import React, { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const PrepareInterview = lazy(() => import("../pages/PrepareInterview"));

export const interviewVersionsRoute = [

  {
    path: "/interviews/:token/questions",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <PrepareInterview />
      </Suspense>
    ),
  },
];
